<template>
  <section
    class="hero"
    style="position: relative; z-index: 0"
    :style="{ '--hero-image-url': heroVideoUrl ? 'none' : null }"
  >
    <!-- A configured video replaces both default and route-specific header images. -->
    <div v-if="heroVideoUrl" class="hero__video-wrapper">
      <video aria-hidden="true" playsinline autoplay muted loop>
        <source :src="heroVideoPath" />
      </video>
    </div>
    <v-container class="hero__filter-container">
      <div
        class="d-flex hero__filter-container__mobile-filter"
        v-if="hasMobileFilter"
      >
        <fulltext-search filled class="mr-4"></fulltext-search>
        <mobile-filter></mobile-filter>
      </div>
    </v-container>
    <v-container class="hero__claim-wrapper">
      <h1 v-if="heroClaim" class="d-block" v-html="heroClaim" />
      <v-row v-if="hasSearchField" class="d-none d-md-flex">
        <v-col cols="12" class="d-flex">
          <fulltext-search
            filled
            bordered
            class="flex-grow-1"
          ></fulltext-search>

          <template v-if="hasJoboffersButton">
            <v-btn
              :to="{ name: 'jobs', query: { show: 'all' } }"
              class="ml-4 hero__filter-container__all-jobs-button"
              >{{ $t('jobs.allJoboffers') }}</v-btn
            >
          </template>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import mobileFilter from '@/components/jobs/mobile-filter.vue';
import fulltextSearch from '@/components/fulltext-search.vue';

import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    heroClaim: {
      type: String,
      required: false,
      default: ''
    },

    hasSearchField: {
      type: Boolean,
      required: false,
      default: false
    },

    hasJoboffersButton: {
      type: Boolean,
      required: false,
      default: false
    },

    hasMobileFilter: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  computed: {
    ...mapState('companyModule', {
      heroVideoUrl: 'heroVideoUrl',
      slug: 'slug'
    }),

    ...mapGetters('companyModule', {
      apiUrl: 'currentCompanyApiUrl'
    }),

    heroVideoPath() {
      let url = '';
      if (this.heroVideoUrl) {
        url = `${this.apiUrl}/file/public?slug=${this.slug}&fileName=${this.heroVideoUrl}`;
      }

      return url;
    }
  },

  components: {
    mobileFilter,
    fulltextSearch
  }
};
</script>
